// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "b9f1b0243a7e673e9ad1" + ".chunk.js";
};